import packageJson from "../../package.json";

export const ENV = {
    DEV: import.meta.env.DEV,
    ZOHO_ELITHAIR_SSO_URL:
        import.meta.env.VITE_ZOHO_ELITHAIR_SSO_URL || "https://one.zoho.com/p/700227663/app/70704000002384019/sso",
    ZOHO_BIOHAIR_SSO_URL:
        import.meta.env.VITE_ZOHO_BIOHAIR_SSO_URL || "https://one.zoho.eu/p/20081289993/app/51844000000217001/sso",
    ZOHO_YESSMILE_SSO_URL:
        import.meta.env.VITE_ZOHO_BIOHAIR_SSO_URL || "https://one.zoho.eu/p/20083018239/app/67409000000467001/sso",
    ZOHO_RHINOMEDICA_SSO_URL:
        import.meta.env.VITE_ZOHO_BIOHAIR_SSO_URL || "https://one.zoho.eu/p/20101457997/app/169808000000054001/sso",
    AUTH_SVC_URL:
        import.meta.env.VITE_AUTH_SVC_URL ||
        (import.meta.env.DEV ? "https://dev.svc.elithair.tech/api/auth-svc" : "https://svc.elithair.tech/api/auth-svc"),
    TREATMENT_SVC_URL:
        import.meta.env.VITE_TREATMENT_SVC_URL ||
        (import.meta.env.DEV
            ? "https://dev.svc.elithair.tech/api/treatment-svc"
            : "https://svc.elithair.tech/api/treatment-svc"),
    FIREBASE_VAPID_KEY:
        import.meta.env.VITE_FIREBASE_VAPID_KEY ||
        "BE2rQrNe7gnb3qKTPHVb-xARnWSN69GQDokHkhVOsKtTXrCDXytKYmqY9B5VhEIkJJGSU9VVZ3NXrLegNnoSIAw",
    APP_URL: import.meta.env.VITE_APP_URL || "https://elitphone.elithair.tech",
    CUSTOM_LOGIN_URL: import.meta.env.VITE_CUSTOM_LOGIN_URL || undefined,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    RELEASE_VERSION: packageJson.version,
    FIREBASE_CONFIG: getFirebaseConfig(),
    SOCKET_URL: import.meta.env.VITE_SOCKET_URL || "wss://dev.svc.elithair.tech",

    // Strapi
    STRAPI_URL: import.meta.env.VITE_STRAPI_URL || "https://strapi.elithair.tech",
};
type FirebaseConfig = {
    apiKey: string;

    authDomain: string;
    projectId: string;

    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
};

function getFirebaseConfig() {
    try {
        const config = import.meta.env.VITE_FIREBASE_CONFIG;
        if (!config || config === "undefined") {
            console.warn("VITE_FIREBASE_CONFIG is not set or is undefined");
            return null;
        }
        return JSON.parse(config) as FirebaseConfig;
    } catch (error) {
        console.error("Invalid JSON in VITE_FIREBASE_CONFIG:", error);
        return null;
    }
}
